module.exports = __webpack_public_path__ + "img/web.315173b0.svg";